export var EntityType;
(function (EntityType) {
    EntityType["Alert"] = "Alert";
    EntityType["Error"] = "Error";
    EntityType["Mapping"] = "Mapping";
    EntityType["SessionReplay"] = "SessionReplay";
    EntityType["UserJourney"] = "UserJourney";
    EntityType["Workspace"] = "Workspace";
})(EntityType || (EntityType = {}));
//# sourceMappingURL=entity-type.js.map